import { render } from "./login-footer.vue?vue&type=template&id=281ec556&scoped=true"
import script from "./login-footer.vue?vue&type=script&lang=js"
export * from "./login-footer.vue?vue&type=script&lang=js"

import "./login-footer.vue?vue&type=style&index=0&id=281ec556&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/kj-wx-web-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281ec556"]])

export default __exports__